import { 
  Settings as SettingsIcon, 
  User, 
  Bell, 
  Shield, 
  Globe,
  Volume2,
  Eye,
  Save
} from 'lucide-react'
import { Button } from '../components/ui/button'

const Settings = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900 pt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center mb-8">
          <SettingsIcon className="w-10 h-10 mr-3 text-purple-400" />
          <div>
            <h1 className="text-4xl font-bold text-white">Settings</h1>
            <p className="text-gray-400">Customize your gaming experience</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-6">
            {/* Account Settings */}
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-white/10 p-6">
              <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                <User className="w-5 h-5 mr-2" />
                Account Settings
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Commander Name
                  </label>
                  <input
                    type="text"
                    defaultValue="Space Commander"
                    className="w-full bg-slate-700/50 border border-gray-600 rounded-lg px-4 py-3 text-white"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    defaultValue="commander@empire.space"
                    className="w-full bg-slate-700/50 border border-gray-600 rounded-lg px-4 py-3 text-white"
                  />
                </div>
              </div>
            </div>

            {/* Notification Settings */}
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-white/10 p-6">
              <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                <Bell className="w-5 h-5 mr-2" />
                Notifications
              </h3>
              <div className="space-y-4">
                {[
                  'Fleet movements',
                  'Combat alerts',
                  'Research completion',
                  'Diplomatic messages',
                  'Resource updates'
                ].map((setting) => (
                  <div key={setting} className="flex items-center justify-between">
                    <span className="text-gray-300">{setting}</span>
                    <input type="checkbox" defaultChecked className="w-4 h-4" />
                  </div>
                ))}
              </div>
            </div>

            {/* Privacy Settings */}
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-white/10 p-6">
              <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                <Shield className="w-5 h-5 mr-2" />
                Privacy & Security
              </h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-gray-300">Show online status</div>
                    <div className="text-sm text-gray-500">Let others see when you're active</div>
                  </div>
                  <input type="checkbox" defaultChecked className="w-4 h-4" />
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-gray-300">Allow direct messages</div>
                    <div className="text-sm text-gray-500">Receive messages from other players</div>
                  </div>
                  <input type="checkbox" defaultChecked className="w-4 h-4" />
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            {/* Game Settings */}
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-white/10 p-6">
              <h3 className="text-lg font-bold text-white mb-4 flex items-center">
                <Globe className="w-5 h-5 mr-2" />
                Game Settings
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Auto-save interval
                  </label>
                  <select className="w-full bg-slate-700/50 border border-gray-600 rounded-lg px-4 py-3 text-white">
                    <option>Every 5 minutes</option>
                    <option>Every 10 minutes</option>
                    <option>Every 30 minutes</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Audio Settings */}
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-white/10 p-6">
              <h3 className="text-lg font-bold text-white mb-4 flex items-center">
                <Volume2 className="w-5 h-5 mr-2" />
                Audio
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Master Volume
                  </label>
                  <input type="range" min="0" max="100" defaultValue="75" className="w-full" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Sound Effects
                  </label>
                  <input type="range" min="0" max="100" defaultValue="80" className="w-full" />
                </div>
              </div>
            </div>

            {/* Display Settings */}
            <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-white/10 p-6">
              <h3 className="text-lg font-bold text-white mb-4 flex items-center">
                <Eye className="w-5 h-5 mr-2" />
                Display
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Theme
                  </label>
                  <select className="w-full bg-slate-700/50 border border-gray-600 rounded-lg px-4 py-3 text-white">
                    <option>Dark (Default)</option>
                    <option>Light</option>
                    <option>Auto</option>
                  </select>
                </div>
              </div>
            </div>

            <Button className="w-full bg-gradient-to-r from-purple-600 to-blue-600">
              <Save className="w-4 h-4 mr-2" />
              Save Changes
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Settings